import CustomInput from "@/components/shared/CustomInput";
import CustomSelect from "@/components/shared/CustomSelect";
import DashboardConstants from "@/store/constants/dashboardRecords";
import TrashIcon from "@/components/shared/TrashIcon"
import GlobalConstants from "@/store/constants/global"

export default {
  name: "SafetyPlanRecordsTable",
  components: {
    CustomInput,
    CustomSelect,
    TrashIcon,
  },
  data() {
    return {
      safetyPlanRecordsFields: [
        { key: "plan", label: this.$t("hazardTable.heading.hazard"), thClass: 'th-plan-header-title' },
        { key: "confirmation", label: this.$t("hazardTable.heading.confirmed") },
        { key: "confirmer", label: this.$t("hazardTable.heading.confirmer") },
        { key: "binIcon", label: "" },
      ],
      confirmationOptions: [
        { key: null, value: "" },
        { key: 'yes', value: '〇' },
        { key: 'no', value: '✕' }
      ],
      formatSafetyPlan: `cus-border-x-table-default cus-bg-header cus-cell-last-child-none
        cus-padding-table-none cus-bg-table cus-font-size-main print-table-cell-right-none cus-page-break html2canvas-page-break`
    };
  },
  methods: {
    showConfirmModal(orderId) {
      this.$bvModal.show('confirm-modal');
      this.$store.commit(GlobalConstants.COMMIT.setConfirmAttr, { attr: "safetyPlans", orderId: orderId });
    },
    setSafetyPlanRecords(attr, value, index) {
      const path = ["safetyPlans", index, attr];
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: path, value: value });
      attr == "confirmation" && this.$store.commit(DashboardConstants.COMMIT.recalculateRevision);
    },
    addNewLineSafetyPlan() {
      this.$store.commit(DashboardConstants.COMMIT.addNewRecord, "safetyPlans");
    },
    handleFocusLine(subAttr, index, status) {
      //handle lost focus
      let obj = { attr: "safetyPlans", index: index, subAttr: subAttr, status: status };
      this.$store.commit(DashboardConstants.COMMIT.changeStatusFocus, obj);
      !status && this.$store.commit(DashboardConstants.COMMIT.recalculateRevision);
    },
  },
  computed: {
    statusEditable() {
      return this.$store.getters[DashboardConstants.GETTERS.getStatusEditable];
    },
    diaryPrevious() {
      let safetyPlansRecord = this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions].safetyPlans;
      return safetyPlansRecord;
    }
  }
};